export default __webpack_public_path__ + "assets/8391e07aec16b9d236c28dfbd8e3b94c/05.jpg";